module.exports = __webpack_public_path__ + "static/media/Internationalbanner@3x.74dcf04f.png";